import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ProjectActivity } from '../../../data/project/activity/project-activity';
import { Project } from '../../../data/project/project';
import { WsUpdateResponce } from '../../../../data/ws-update-responce';
import { WsService } from '../../../../data/ws.service';
import { ProjectActivityService } from '../../../data/project/activity/project-activity.service';
import { trackEntityById } from 'projects/core/src/public-api';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-project-activities-block',
    templateUrl: './project-activities-block.component.html',
    styleUrls: ['./project-activities-block.component.scss']
})
@RxJSUnsubscribe
export class ProjectActivitiesBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    @Input()
    projectActivities: ProjectActivity[];

    @Input()
    projectId: number;

    trackEntityById = trackEntityById;

  wsSub: Subscription;
    constructor(
        protected wsService: WsService,
        private projectActivityService: ProjectActivityService
    ) { }

    ngOnInit() {
    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<ProjectActivity>>('/topic/update/model.activity.Activity', this)
            .pipe(
                filter(updateInfo => {
                    if (updateInfo.entity.project && updateInfo.entity.project.id === this.projectId) {
                        return true;
                    }
                    else if (!updateInfo.entity.project && !!this.projectActivities.find(activity => activity.id === updateInfo.entity.id)) {
                        return true;
                    }
                    return false
                }),
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.getProjectActivities();
            })
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
    }

    getProjectActivities() {
        this.projectActivityService.getProjectActivities(this.projectId).subscribe(projectActivities => {
            this.projectActivities = projectActivities
        })
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }


}
